module.exports = __webpack_public_path__ + "img/3442f0794cde4ae9023d26e9d8be0de1.a0c4f2ce.jpg";